import { createApiService } from './createApiService'

export const importAPI = createApiService({
  reducerPath: 'importAPI',
  tagTypes: ['Art'],
  endpoints: (build: any) => ({
    importImdbMovie: build.mutation({
      query: (imdbId: string) => ({
        url: '/import/imdb',
        method: 'POST',
        body: { imdbId },
      }),
      invalidatesTags: ['Art'],
    }),
    bulkImportImdbMovies: build.mutation({
      query: (imdbIds: string[]) => ({
        url: '/import/imdb/bulk',
        method: 'POST',
        body: { imdbIds },
      }),
      invalidatesTags: ['Art'],
    }),
  }),
})

export const {
  useImportImdbMovieMutation,
  useBulkImportImdbMoviesMutation
} = importAPI